export enum ChatgptListingStatus {
  Active = "ACTIVE",
  Draft = "DRAFT",
  Archived = "ARCHIVED",
}
